export default __webpack_public_path__ + "static/media/021-nuclear plant.03d3b954.svg";